import 'react';
import 'web-ui-kit/assets/InboxIcon';
import 'web-ui-kit/menus';
import 'lodash/get';
import 'web-ui-kit/routes';
import 'web-ui-kit/assets/ReferAFriendIcon';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * How It Works data
 */


var HOW_IT_WORKS_DROPDOWN_LABELS = {
  MODSY_VS_TRADITIONAL: 'Modsy vs. Traditional Designers',
  DIFFERENCE: 'The Modsy 3D Difference',
  DESIGN_SERVICE: 'Design Service Q&A',
  INTERIOR_DESIGN_101: 'Interior Design 101'
};

var HOW_IT_WORKS_DRAWER_LABELS = _objectSpread2({
  HOW_IT_WORKS_HOME: 'How It Works'
}, HOW_IT_WORKS_DROPDOWN_LABELS);
/**
 * Blog data
 */


var BLOG_DROPDOWN_LABELS = {
  TIPS: 'Tips & Guides',
  REAL_STORIES: 'Real Stories',
  INSPIRATION: 'Style Inspiration',
  LAYOUT: 'Layout Guides',
  MODSY_101: 'Modsy 101'
};

var BLOG_DRAWER_LABELS = _objectSpread2({
  BLOG_HOME: 'Blog Home'
}, BLOG_DROPDOWN_LABELS);
/**
 * Design Ideas data
 */


var DESIGN_IDEAS_DROPDOWN_LABELS = {
  BEDROOM: 'Bedroom Design Ideas',
  DINING: 'Dining Room Design Ideas',
  OFFICE: 'Home Office Design Ideas',
  KIDS: "Kid's Bedroom Design Ideas",
  LIVING_ROOM: 'Living Room Design Ideas'
};

var DESIGN_IDEAS_DRAWER_LABELS = _objectSpread2({
  ALL: 'All Design Ideas'
}, DESIGN_IDEAS_DROPDOWN_LABELS);

var ACCOUNT_DROPDOWN_LABELS = {
  ACCOUNT: 'Accounts Settings',
  HISTORY: 'Order History',
  LOGOUT: 'Logout'
};
var ACCOUNT_DRAWER_LABELS = {
  ACCOUNT: 'My Account',
  HISTORY: 'Order History',
  HELP: 'Help',
  LOGOUT: 'Logout'
};
/**
 * Help data
 */

var HELP_DROPDOWN_LABELS = {
  HELP_CENTER: 'Help Center',
  GETTING_STARTED_WITH_MODSY: 'Getting Started - Your Designs Page',
  USING_3D_EDITOR: 'Using the Modsy 3D Editor'
};
var HEADER_NAMES = {
  MY_PROJECTS: 'My Projects',
  PROJECTS: 'Projects',
  MODSY_PRO: 'Modsy Pro',
  HOW_IT_WORKS: 'How It Works',
  PRICING: 'Pricing',
  EXAMPLES: 'Examples',
  BEFORE_AND_AFTER: 'Before & After',
  GIFT_CARDS: 'Gift Cards',
  STYLE_QUIZ: 'Style Quiz',
  DESIGN_IDEAS: 'Design Ideas',
  IDEAS: 'Ideas',
  BLOG: 'Blog',
  ACCOUNT: 'Account',
  LOGIN: 'Login',
  START_YOUR_PROJECT: 'Start Your Project',
  HELP: 'Help'
};

var _allRoutes;
/**
 * Define per environment URL constants.
 * We will need these when we need to
 * construct full URLs during SSR.
 */


var WAREHOUSE_URL = {
  local: 'http://localhost:3000',
  // web-post-purchase app runs locally on port 3000
  dev: 'https://www.dev.modsy.com',
  staging: 'https://www.staging.modsy.com',
  prod: 'https://www.modsy.com'
};
/**
 * Inter-app routes between nextjs and web-post-purchase apps
 * require a full page reload and thus a fully formed base URL.
 */

function computeWarehouseClientUrl(appEnv) {
  // Allows local dev to specify a specific base URL for warehouse client.
  // Can be used to link locally running nextjs app to locally running
  // web-post-purchase app.
  // Example:
  //  WAREHOUSE_CLIENT_URL=http://0.0.0.0:3000 yarn start:dev:imgix
  if (process.env.WAREHOUSE_CLIENT_URL) {
    return process.env.WAREHOUSE_CLIENT_URL;
  }

  return WAREHOUSE_URL[appEnv] || '';
}
/**
 * Web post purchase routes.
 * These are inter-app routes requiring a full page refresh.
 */


var webPP = {
  account: function account() {
    return "".concat(computeWarehouseClientUrl(), "/account");
  },
  login: function login() {
    return "".concat(computeWarehouseClientUrl(), "/login");
  },
  projectOnboarding: function projectOnboarding() {
    return "".concat(computeWarehouseClientUrl(), "/project/room");
  },
  referFriend: function referFriend() {
    return "".concat(computeWarehouseClientUrl(), "/friend");
  },
  referralDashboard: function referralDashboard() {
    return "".concat(computeWarehouseClientUrl(), "/referrals");
  },
  merchCheckout: function merchCheckout(_ref) {
    var _ref$pathname = _ref.pathname,
        pathname = _ref$pathname === void 0 ? '' : _ref$pathname,
        _ref$isRedirecting = _ref.isRedirecting,
        isRedirecting = _ref$isRedirecting === void 0 ? false : _ref$isRedirecting,
        _ref$includePdpFlag = _ref.includePdpFlag;
    var appEnv = '';

    if (isRedirecting && typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      appEnv = 'local';
    }

    var returnTo = 'Design+Ideas'; // text displayed in Checkout

    var href = "".concat(computeWarehouseClientUrl(appEnv), "/shop/cart");
    var path = pathname;
    var search = "?direct=true&from=".concat(path, "&returnTo=").concat(returnTo);
    return "".concat(href).concat(search);
  }
};
/**
 * External routes.
 * These are routes to related Modsy apps on different domains.
 */

var external = {
  blog: 'https://blog.modsy.com/',
  faqs: 'https://help.modsy.com/',
  modsy101: 'https://blog.modsy.com/news/',
  roomGallery: 'https://blog.modsy.com/room-gallery/',
  styleInspiration: 'https://blog.modsy.com/style-inspiration/',
  realStories: 'https://blog.modsy.com/real-stories/',
  tipsAndGuides: 'https://blog.modsy.com/tips-guides/',
  helpCenter: 'https://modsy.zendesk.com/hc/en-us',
  gettingStartedWithModsy: 'https://modsy.zendesk.com/hc/en-us/articles/360007463431-I-received-my-initial-designs-now-what-',
  shoppingThroughModsy: 'https://modsy.zendesk.com/hc/en-us/articles/360033173791-How-does-shopping-through-Modsy-work-',
  using3DEditor: 'https://modsy.zendesk.com/hc/en-us/articles/360051650292-Getting-Started-using-the-Modsy-3D-Editor',
  returnsAndExchanges: 'https://modsy.zendesk.com/hc/en-us/articles/360007463151-Modsy-Return-Policy'
};
/**
 * Wordpress routes.
 * These are inter-app routes requiring a full page refresh.
 */

var wordpress = {
  howItWorks: '/how-it-works/',
  theModsy3dDifference: '/3d-online-design-difference/',
  modsyVsTradDesigners: '/online-interior-design-versus-traditional/',
  interiorDesign: '/interior-design-101/',
  faqs: '/online-design-package-faqs/',
  pricing: '/online-interior-design-packages/',
  styleQuiz: '/design-style-quiz/',
  examples: '/real-interior-design-stories/',
  beforeAndAfter: '/real-interior-design-stories/',
  giftCard: '/modsy-gift-cards/',
  homePage: '/'
};
var ALL_APPS = {
  WEB_POST_PURCHASE: 'web-post-purchase',
  WORDPRESS: 'wordpress',
  NEXTJS: 'nextjs',
  EXTERNAL: 'external'
};
var allRoutes = (_allRoutes = {}, _defineProperty(_allRoutes, BLOG_DRAWER_LABELS.BLOG_HOME, {
  destination: external.blog,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, BLOG_DRAWER_LABELS.TIPS, {
  destination: external.tipsAndGuides,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, BLOG_DRAWER_LABELS.MODSY_101, {
  destination: external.modsy101,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, BLOG_DRAWER_LABELS.REAL_STORIES, {
  destination: external.realStories,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, BLOG_DRAWER_LABELS.INSPIRATION, {
  destination: external.styleInspiration,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, BLOG_DRAWER_LABELS.LAYOUT, {
  destination: external.roomGallery,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, HELP_DROPDOWN_LABELS.HELP_CENTER, {
  destination: external.helpCenter,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, HELP_DROPDOWN_LABELS.GETTING_STARTED_WITH_MODSY, {
  destination: external.gettingStartedWithModsy,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, HELP_DROPDOWN_LABELS.SHOPPING_THROUGH_MODSY, {
  destination: external.shoppingThroughModsy,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, HELP_DROPDOWN_LABELS.USING_3D_EDITOR, {
  destination: external.using3DEditor,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, HELP_DROPDOWN_LABELS.RETURNS_AND_EXCHANGES, {
  destination: external.returnsAndExchanges,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, ACCOUNT_DROPDOWN_LABELS.ACCOUNT, {
  destination: webPP.account(),
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, ACCOUNT_DRAWER_LABELS.ACCOUNT, {
  destination: webPP.account(),
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, ACCOUNT_DRAWER_LABELS.HISTORY, {
  destination: '/account/order-history',
  app: ALL_APPS.NEXTJS,
  slug: ''
}), _defineProperty(_allRoutes, ACCOUNT_DRAWER_LABELS.HELP, {
  destination: external.faqs,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, ACCOUNT_DRAWER_LABELS.LOGOUT, {
  destination: webPP.login(),
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, "referrals", {
  destination: webPP.referralDashboard(),
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.BLOG, {
  destination: external.blog,
  app: ALL_APPS.EXTERNAL,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.DESIGN_IDEAS, {
  destination: '/design-ideas',
  app: ALL_APPS.NEXTJS,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.ACCOUNT, {
  destination: '/account',
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.START_YOUR_PROJECT, {
  destination: webPP.projectOnboarding(),
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.LOGIN, {
  destination: webPP.login(),
  app: ALL_APPS.WEB_POST_PURCHASE,
  slug: ''
}), _defineProperty(_allRoutes, HOW_IT_WORKS_DRAWER_LABELS.HOW_IT_WORKS_HOME, {
  destination: wordpress.howItWorks,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HOW_IT_WORKS_DRAWER_LABELS.DIFFERENCE, {
  destination: wordpress.theModsy3dDifference,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HOW_IT_WORKS_DRAWER_LABELS.MODSY_VS_TRADITIONAL, {
  destination: wordpress.modsyVsTradDesigners,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HOW_IT_WORKS_DRAWER_LABELS.INTERIOR_DESIGN_101, {
  destination: wordpress.interiorDesign,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HOW_IT_WORKS_DRAWER_LABELS.DESIGN_SERVICE, {
  destination: wordpress.faqs,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.PRICING, {
  destination: wordpress.pricing,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.STYLE_QUIZ, {
  destination: wordpress.styleQuiz,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.EXAMPLES, {
  destination: wordpress.examples,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.BEFORE_AND_AFTER, {
  destination: wordpress.beforeAndAfter,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, HEADER_NAMES.GIFT_CARDS, {
  destination: wordpress.giftCard,
  app: ALL_APPS.WORDPRESS,
  slug: ''
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DROPDOWN_LABELS.LIVING_ROOM, {
  destination: '/design-ideas/living-room',
  app: ALL_APPS.NEXTJS,
  slug: 'living-room'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DROPDOWN_LABELS.BEDROOM, {
  destination: '/design-ideas/bedroom',
  app: ALL_APPS.NEXTJS,
  slug: 'bedroom'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DROPDOWN_LABELS.OFFICE, {
  destination: '/design-ideas/home-office',
  app: ALL_APPS.NEXTJS,
  slug: 'home-office'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DROPDOWN_LABELS.DINING, {
  destination: '/design-ideas/dining-room',
  app: ALL_APPS.NEXTJS,
  slug: 'dining-room'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DROPDOWN_LABELS.KIDS, {
  destination: '/design-ideas/kids-room',
  app: ALL_APPS.NEXTJS,
  slug: 'kids-room'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DRAWER_LABELS.ALL, {
  destination: '/design-ideas',
  app: ALL_APPS.NEXTJS,
  slug: ''
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DRAWER_LABELS.BEDROOM, {
  destination: '/design-ideas/bedroom',
  app: ALL_APPS.NEXTJS,
  slug: 'bedroom'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DRAWER_LABELS.DINING, {
  destination: '/design-ideas/dining-room',
  app: ALL_APPS.NEXTJS,
  slug: 'dining-room'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DRAWER_LABELS.OFFICE, {
  destination: '/design-ideas/home-office',
  app: ALL_APPS.NEXTJS,
  slug: 'home-office'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DRAWER_LABELS.LIVING_ROOM, {
  destination: '/design-ideas/living-room',
  app: ALL_APPS.NEXTJS,
  slug: 'living-room'
}), _defineProperty(_allRoutes, DESIGN_IDEAS_DRAWER_LABELS.KIDS, {
  destination: '/design-ideas/kids-room',
  app: ALL_APPS.NEXTJS,
  slug: 'kids-room'
}), _allRoutes);
export { WAREHOUSE_URL, allRoutes, computeWarehouseClientUrl, external, webPP, wordpress };